import { apiFetch } from "../utils/apiFetch"

export type DesignerSearchResult = {
  designerIdentifier: string
  name: string
}

export function searchDesigners(designerName: string) {
  const query = new URLSearchParams({ designerName })

  return apiFetch(
    `/api/euipo/design-filing/designers/search?${query.toString()}`
  ) as Promise<DesignerSearchResult[]>
}
